import { render, staticRenderFns } from "./ErrorsList.vue?vue&type=template&id=3c8ce935&"
import script from "./ErrorsList.vue?vue&type=script&lang=js&"
export * from "./ErrorsList.vue?vue&type=script&lang=js&"
import style0 from "./ErrorsList.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../Яндекс.Игнор/PhpStormProject/app.glavdor.pro/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports